import React from 'react';
import './Landing.css'
import Hero from '../../components/Hero/Hero';
import HowItWorks from '../../components/HowItWorks/HowItWorks';
import RegisterPage from '../Register/RegisterPage';
import Footer from '../../components/Footer/Footer';
import useDarkOffersBackground from '../../hooks/useDarkOffersBackground';

export default function HomePage() {
  useDarkOffersBackground();
  return (
    <div className="Landing">
      <Hero />
      <HowItWorks />
      
    </div>
  )
}
